<template>
  <div class="offcanvas offcanvas-end" id="OffcanvasForm" ref="offcanvas" data-bs-backdrop="static">
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'CREATE'? $t('_delivery.Create Delivery Channel'): $t('_delivery.Edit Delivery Channel') }}
      <button type="button" style="font-size: small;" class="btn-close shadow-none text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
    </div>

    <div class="offcanvas-body" v-if="loading">
      <placeholder-content :is-load="true" />
    </div>
    <div class="offcanvas-body" v-else-if="!hasPermission">
      <access-denied/>
    </div>
    <div class="offcanvas-body p-0" v-else>
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-circle-info me-2" />
        {{ $t('_delivery.Channel Information') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-6">
            <label for="code" class="form-label">
              {{ $t('_delivery.Code') }} <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="code"
                type="text"
                v-model.trim="v$.form.code.$model"
                class="form-control shadow-none"
                placeholder="grab, lineman ..."
              >
              <div v-for="error of v$.form.code.$errors" class="d-block invalid-feedback" :key="error.$uid">
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <label for="name" class="form-label">
              {{ $t('_delivery.Channel name') }} <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="name"
                type="text"
                v-model.trim="v$.form.name.$model"
                class="form-control shadow-none"
                placeholder="GrabFood ..."
              >
              <div v-for="error of v$.form.name.$errors" class="d-block invalid-feedback" :key="error.$uid">
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <label for="color" class="form-label">{{ $t('_delivery.Brand color') }}</label>
            <input
              id="color"
              type="color"
              v-model="form.color"
              class="form-control form-control-color shadow-none"
            >
          </div>
          <div class="col-6">
            <label for="sort_order" class="form-label">{{ $t('_delivery.Sort order') }}</label>
            <input
              id="sort_order"
              type="number"
              min="0"
              v-model.number="form.sort_order"
              class="form-control shadow-none"
            >
          </div>
          <div class="col-12">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="is_external" v-model="form.is_external">
              <label class="form-check-label" for="is_external">
                {{ $t('_delivery.External platform (Grab, LINE MAN)') }}
              </label>
            </div>
            <div class="text-muted" style="font-size: 12px;">
              {{ $t('_delivery.External means customer already paid on the app - the bill closes itself and money waits for platform payout') }}
            </div>
          </div>
          <template v-if="form.is_external">
            <!-- กลุ่มค่า GP (คอมมิชชั่น) -->
            <div class="col-12">
              <div class="border rounded-3 p-3">
                <div class="fw-semibold small text-secondary mb-3">
                  <i class="fa-solid fa-percent me-1"/>{{ $t('_delivery.Commission (GP)') }}
                </div>
                <div class="row g-3">
                  <div :class="form.has_pickup ? 'col-6' : 'col-12'">
                    <label for="default_commission_rate" class="form-label small">{{ $t('_delivery.Delivery GP %') }}</label>
                    <div class="input-group input-group-sm">
                      <input
                        id="default_commission_rate"
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        v-model.number="form.default_commission_rate"
                        class="form-control shadow-none"
                      >
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div class="col-6" v-if="form.has_pickup">
                    <label for="pickup_commission_rate" class="form-label small">{{ $t('_delivery.Pickup GP %') }}</label>
                    <div class="input-group input-group-sm">
                      <input
                        id="pickup_commission_rate"
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        v-model="form.pickup_commission_rate"
                        class="form-control shadow-none"
                        :placeholder="String(form.default_commission_rate || 0)"
                      >
                      <span class="input-group-text">%</span>
                    </div>
                    <div class="text-muted" style="font-size: 11px;">
                      {{ $t('_delivery.Leave empty to use the same GP as delivery') }}
                    </div>
                  </div>
                </div>
                <div class="form-check form-switch mt-3 mb-0">
                  <input class="form-check-input" type="checkbox" id="has_pickup" v-model="form.has_pickup">
                  <label class="form-check-label small" for="has_pickup">
                    {{ $t('_delivery.Customers can self pickup at the store') }}
                  </label>
                </div>
                <div class="text-muted" style="font-size: 11px;">
                  {{ $t('_delivery.Branch override is set in each branch settings') }}
                </div>
              </div>
            </div>

            <!-- กลุ่ม VAT บนค่า GP -->
            <div class="col-12">
              <div class="border rounded-3 p-3">
                <div class="fw-semibold small text-secondary mb-3">
                  <i class="fa-solid fa-receipt me-1"/>{{ $t('_delivery.VAT on GP') }}
                </div>
                <div class="col-6">
                  <label for="commission_vat_rate" class="form-label small">{{ $t('_delivery.VAT %') }}</label>
                  <div class="input-group input-group-sm">
                    <input
                      id="commission_vat_rate"
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      v-model.number="form.commission_vat_rate"
                      class="form-control shadow-none"
                      :disabled="form.commission_vat_included"
                    >
                    <span class="input-group-text">%</span>
                  </div>
                </div>
                <div class="form-check form-switch mt-3 mb-0">
                  <input class="form-check-input" type="checkbox" id="commission_vat_included" v-model="form.commission_vat_included">
                  <label class="form-check-label small" for="commission_vat_included">
                    {{ $t('_delivery.GP rate already includes VAT') }}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="requires_external_ref" v-model="form.requires_external_ref">
                <label class="form-check-label" for="requires_external_ref">
                  {{ $t('_delivery.Require platform order no when keying') }}
                </label>
              </div>
            </div>

          </template>
        </div>
      </div>
    </div>
    <div class="bg-light border-top justify-content-center modal-footer py-2" v-if="!loading && hasPermission">
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleEdit"
      />
      <button type="button" data-bs-dismiss="offcanvas" class="border-dark-subtle btn-sm btn btn-light me-2 ms-2">
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { DeliveryPlatforms } from '@/services/endpoint/delivery-platforms.service';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: { $lazy: true },
  validations() {
    return validation(this.form)
  },
  props: {
    type: { type: String, default: 'CREATE' },
    id: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: true,
      hasPermission: false,
      loadingSave: false,
      form: {
        code: '',
        name: '',
        color: '#6B7280',
        icon: '',
        is_external: true,
        has_pickup: false,
        default_commission_rate: 30,
        pickup_commission_rate: '',
        commission_vat_included: false,
        commission_vat_rate: 7,
        requires_external_ref: true,
        sort_order: 0
      }
    }
  },
  components: { PlaceholderContent, Ladda, AccessDenied },
  methods: {
    async getUpdateData() {
      await DeliveryPlatforms.getUpdate(this.id).then(res => {
        const data = res.data.data;
        this.form = {
          code: data.code,
          name: data.name,
          color: data.color || '#6B7280',
          icon: data.icon || '',
          is_external: !!data.is_external,
          has_pickup: !!data.has_pickup,
          default_commission_rate: parseFloat(data.default_commission_rate) || 0,
          pickup_commission_rate: (data.pickup_commission_rate !== null && data.pickup_commission_rate !== undefined) ? parseFloat(data.pickup_commission_rate) : '',
          commission_vat_included: !!data.commission_vat_included,
          commission_vat_rate: parseFloat(data.commission_vat_rate) || 0,
          requires_external_ref: !!data.requires_external_ref,
          sort_order: data.sort_order || 0
        };
        this.hasPermission = true;
      }).catch(err => { throw err; });
    },
    async handleEdit() {
      this.loadingSave = true;
      this.v$.$touch();
      if (this.v$.$invalid) { this.loadingSave = false; return; }
      const payload = { ...this.form, pickup_commission_rate: this.form.pickup_commission_rate === '' ? null : Number(this.form.pickup_commission_rate) };
      await DeliveryPlatforms.update(this.id, payload).then(() => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) this.$toast.warn(this.$t(err?.response?.data?.message));
        this.loadingSave = false;
      });
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if (this.v$.$invalid) { this.loadingSave = false; return; }
      const payload = { ...this.form, pickup_commission_rate: this.form.pickup_commission_rate === '' ? null : Number(this.form.pickup_commission_rate) };
      await DeliveryPlatforms.create(payload).then(() => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) this.$toast.warn(this.$t(err?.response?.data?.message));
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');
    $(this.$refs.offcanvas).on('shown.bs.offcanvas', async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') this.hasPermission = true;
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {}
    });
    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFroms.open = false;
    });
  }
}
</script>
